/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Directive, EmbeddedViewRef, Input, TemplateRef, ViewContainerRef} from '@angular/core';

import {isPresent} from '../facade/lang';
export class NgTemplateOutlet {
  private _viewRef: EmbeddedViewRef<any>;
  private _context: Object;
  private _templateRef: TemplateRef<any>;

  constructor(private _viewContainerRef: ViewContainerRef) {}
  set ngOutletContext(context: Object) {
    if (this._context !== context) {
      this._context = context;
      if (isPresent(this._viewRef)) {
        this.createView();
      }
    }
  }
  set ngTemplateOutlet(templateRef: TemplateRef<Object>) {
    if (this._templateRef !== templateRef) {
      this._templateRef = templateRef;
      this.createView();
    }
  }

  private createView() {
    if (isPresent(this._viewRef)) {
      this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._viewRef));
    }

    if (isPresent(this._templateRef)) {
      this._viewRef = this._viewContainerRef.createEmbeddedView(this._templateRef, this._context);
    }
  }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[ngTemplateOutlet]'}, ] },
];
/** @nocollapse */
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: ViewContainerRef, },
];
/** @nocollapse */
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngOutletContext': [{ type: Input },],
'ngTemplateOutlet': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
